import { render, staticRenderFns } from "./gNoContent.vue?vue&type=template&id=2a7d7adf&scoped=true"
import script from "./gNoContent.vue?vue&type=script&lang=js"
export * from "./gNoContent.vue?vue&type=script&lang=js"
import style0 from "./gNoContent.vue?vue&type=style&index=0&id=2a7d7adf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7d7adf",
  null
  
)

export default component.exports